<template>
    <v-container class="py-0 pl-0 main-menu">
        <v-layout>
            <v-menu
                    transition="slide-y-transition"
                    bottom
                    v-model="menu"
                    :open-on-hover="true"
                    :close-on-click="true"
                    :close-on-content-click="true"
                    :offset-y="true"
            >
                <template v-slot:activator="{ on }">
                    <v-btn
                            color="primary"
                            dark
                            v-on="on"
                            tile
                            depressed
                            x-large
                            :loading="loadingCategories"
                    >
                        <v-icon left small>fa-bars</v-icon>Naše nabídka
                        <span class="ml-4">
                            <v-icon right v-if="menu" small>fa-chevron-up</v-icon>
                            <v-icon right v-else small>fa-chevron-down</v-icon>
                        </span>
                    </v-btn>
                </template>
                <v-list dense>
                    <v-list-item
                        v-for="item in allCategories" :key="item.id"
                        @click="$router.push('/category/' + item.alias)"
                    >
                        <v-list-item-title>{{ item.name }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-layout>
    </v-container>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'

    export default {
        name: 'Menu',
        data () {
            return {
                menu: false
            }
        },
        computed: {
            ...mapGetters([
                'loadingCategories',
                'allCategories'
            ])
        },
        mounted() {
            if (!this.allCategories.length) {
                this.retrieveCategories();
            }
        },
        methods: {
            ...mapActions([
                'retrieveCategories'
            ])
        }
    }
</script>

<style lang="scss">
    .main-menu {
        border-top: 1px solid rgba(88, 88, 88, 1);
    }
</style>

